module.exports = __webpack_public_path__ + "img/social.750a5b1f.svg";